<template>
    <div id="banner">
        <a href="#">
            <img src="../../assets/images/banner-1.png" class="banner" alt="banner-img">
        </a>
    </div>
</template>

<script>
    export default {
        name: "banner"
    }
</script>


// WEBPACK FOOTER //
// src/components/component/BannerComponent.vue